import { findKey, mapValues } from 'lodash';

// Translations
import itTranslation from '../../../../locales/it/translation.json';
import enTranslation from '../../../../locales/en/translation.json';
import itMic from '../../../../locales/it/mic.json';
import enMic from '../../../../locales/en/mic.json';

// Ant
import it_IT from 'antd/lib/locale-provider/it_IT';
import en_GB from 'antd/lib/locale-provider/en_GB';

// Moment
import moment from 'moment';
import 'moment/locale/it';
// import 'moment/locale/en'; // Non necessario, già incluso in moment.

export const IntlLanguages = {
  it: {
    resources: {
      translation: itTranslation,
      mic: itMic // TODO Caricamento condizionale
    },
    ant: it_IT,
    moment: 'it',
    label: 'ITA',
    name: 'Italiano',
    default: true
  },
  en: {
    resources: {
      translation: enTranslation,
      mic: enMic
    },
    ant: en_GB,
    moment: 'en',
    label: 'ENG',
    name: 'English',
    default: false
  }
};

export type IntlLanguageKey = keyof typeof IntlLanguages;

export function getIntlLanguagesResources() {
  return mapValues(IntlLanguages, lang => lang.resources);
}

export function getIntlDefaultLanguage() {
  const key = findKey(IntlLanguages, lang => lang.default);
  const language = IntlLanguages[key as IntlLanguageKey];

  return { key, language };
}
